import React from 'react';
export type FaqItem = {
  q: string;
  a: React.ReactNode;
};
export const faqs: FaqItem[] = [{
  q: "Isn't this just guardrails, or a system prompt?",
  a: <>
        Guardrails filter after the model answers. A system prompt is prose the model reads top-to-bottom and
        half-forgets by the bottom. Synthia sits <strong data-id="element-332" data-mp="1sg6kuvzpimgi">before</strong> the model, seats the rules that must hold as
        discrete obligations, and proves which ones fired. It governs the instruction, not the aftermath.
      </>
}, {
  q: 'Do I have to rip out my RAG?',
  a: <>
        No. Retrieval is good at finding facts. Synthia governs the rules that must hold regardless of what retrieval
        brings back &mdash; it runs ahead of RAG and hands it a governed vocabulary, so the two work together.
      </>
}, {
  q: 'What counts as a high-consequence workflow?',
  a: <>
        Any output that commits your business &mdash; a regulated claim, a customer-facing decision, a filing, an agent
        that acts without a human reading every step. If a mistake there is expensive <strong data-id="element-333" data-mp="2is33v57k9h87">and</strong> someone can
        be asked to prove it didn't happen, that's the wheelhouse.
      </>
}, {
  q: 'Is my instruction data mine?',
  a: <>
        Yes. The library built from your rules and corrections is private, owned by you, and never returns to any
        marketplace. That's the point &mdash; it's an asset you keep.
      </>
}, {
  q: 'What does it cost us to be wrong today?',
  a: <>
        More than a follow-up question. At the low end it&rsquo;s a rework loop, a compliance review, a customer apology
        &mdash; the tokens spent undoing the first pass. At the high end it&rsquo;s a regulatory violation that runs
        into the millions. A wrong answer scales from tokens to millions &mdash; Synthia governs it before the model
        runs.
      </>
}];